/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Revoke_Error_DescriptionInputs */

const es_user_profile_devices_revoke_error_description = /** @type {(inputs: User_Profile_Devices_Revoke_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el dispositivo`)
};

const en_user_profile_devices_revoke_error_description = /** @type {(inputs: User_Profile_Devices_Revoke_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device could not be removed`)
};

/**
* | output |
* | --- |
* | "The device could not be removed" |
*
* @param {User_Profile_Devices_Revoke_Error_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_revoke_error_description = /** @type {((inputs?: User_Profile_Devices_Revoke_Error_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Revoke_Error_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_revoke_error_description(inputs)
	return en_user_profile_devices_revoke_error_description(inputs)
});
export { user_profile_devices_revoke_error_description as "user.profile.devices.revoke.error_description" }